import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useMemo, useState } from "react";
import dummylogo from "../../asset/avathar.jpg";


const StudentsTable = ({ data = [], loading, onEdit, onDelete }) => {
  const [search, setSearch] = useState("");
  const [course, setCourse] = useState("");
  const [batch, setBatch] = useState("");
  const [branch, setBranch] = useState("");

  const courses = [...new Set(data.map(d => d.CourseName))];
  const batches = [...new Set(data.map(d => d.BatchName))];
  const branches = [...new Set(data.map(d => d.BranchName))];

  console.log(
    "Unique courses:",
    [...new Set(data.map(d => d.CourseName))]
  );


  const filteredData = useMemo(() => {
    return data.filter(d => {
      const matchesSearch =
        d.StudentName?.toLowerCase().includes(search.toLowerCase()) ||
        d.ParentUserName?.toLowerCase().includes(search.toLowerCase()) ||
        d.ParentPhoneNumber?.includes(search);

      const matchesCourse = course ? d.CourseName === course : true;
      const matchesBatch = batch ? d.BatchName === batch : true;
      const matchesBranch = branch ? d.BranchName === branch : true;

      return (
        matchesSearch &&
        matchesCourse &&
        matchesBatch &&
        matchesBranch
      );
    });
  }, [data, search, course, batch, branch]);

  if (loading) return <p>Loading students...</p>;
  if (!data.length) return <p>No students found</p>;

  const getExportData = () =>
    filteredData.map(d => ({
      Student: d.StudentName,
      Parent: d.ParentUserName,
      Phone: d.ParentPhoneNumber,
      Course: d.CourseName,
      Batch: d.BatchName,
      Branch: d.BranchName,
      Fees: d.MonthlyFees,
    }));

  const exportExcel = () => {
    const sheet = XLSX.utils.json_to_sheet(getExportData());
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, sheet, "Students");

    const buf = XLSX.write(wb, { type: "array", bookType: "xlsx" });
    saveAs(new Blob([buf]), "Students_List.xlsx");
  };

  const exportCSV = () => {
    const sheet = XLSX.utils.json_to_sheet(getExportData());
    const csv = XLSX.utils.sheet_to_csv(sheet);
    saveAs(
      new Blob([csv], { type: "text/csv;charset=utf-8;" }),
      "Students_List.csv"
    );
  };


  return (
    <div className="table-card">
      <div className="table-toolbar">
        <input
          type="text"
          placeholder="Search student / parent / phone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />

        <select value={branch} onChange={(e) => setBranch(e.target.value)}>
          <option value="">All Branches</option>
          {branches.map(b => (
            <option key={b} value={b}>{b}</option>
          ))}
        </select>

        <select value={course} onChange={(e) => setCourse(e.target.value)}>
          <option value="">All Courses</option>
          {courses.map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <select value={batch} onChange={(e) => setBatch(e.target.value)}>
          <option value="">All Batches</option>
          {batches.map(b => (
            <option key={b} value={b}>{b}</option>
          ))}
        </select>

        {/* ⬇ EXPORT BUTTONS */}
        <div className="table-actions">
          <button onClick={exportExcel}>⬇ Excel</button>
          <button onClick={exportCSV}>⬇ CSV</button>
        </div>
      </div>

      <div className="table-wrapper">
        <table className="students-table">
          <thead>
            <tr>
              <th>Student</th>
              <th>Course</th>
              <th>Batch</th>
              <th>Branch</th>
              <th className="fees">Fees</th>
              <th className="actions">Actions</th>
            </tr>
          </thead>


          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">
                  No matching students
                </td>
              </tr>
            ) : (
              filteredData.map((row) => (
                <tr key={row.StudentId}>
                  <td>
                    <div className="student-cell">
                      <img
                        src={row.StudentProfilePicUrl || dummylogo}
                        alt={row.StudentName}

                      />
                      <span>{row.StudentName}</span>
                    </div>
                  </td>

                  <td>{row.CourseName}</td>
                  <td>{row.BatchName}</td>
                  <td>{row.BranchName}</td>
                  <td className="fees">₹{row.MonthlyFees}</td>

                  <td className="actions">
                    <button className="action-btn edit" onClick={() => onEdit(row)}>
                      Edit
                    </button>
                    <button className="action-btn delete" onClick={() => onDelete?.(row)}>
                      Delete
                    </button>
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentsTable;
